/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeObservedReportApiRequest } from '../../models/change-observed-report-api-request';
import { StatusedBasedResponseInfoResultApiResult } from '../../models/statused-based-response-info-result-api-result';

export interface ApiHotelHotelSellReportChangeObservedPost$Params {
      body: ChangeObservedReportApiRequest
}

export function apiHotelHotelSellReportChangeObservedPost(http: HttpClient, rootUrl: string, params: ApiHotelHotelSellReportChangeObservedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusedBasedResponseInfoResultApiResult>> {
  const rb = new RequestBuilder(rootUrl, apiHotelHotelSellReportChangeObservedPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatusedBasedResponseInfoResultApiResult>;
    })
  );
}

apiHotelHotelSellReportChangeObservedPost.PATH = '/api/hotel/HotelSellReport/ChangeObserved';
